import { render, staticRenderFns } from "./NewsListSection.vue?vue&type=template&id=1271e5ba"
import script from "./NewsListSection.vue?vue&type=script&lang=js"
export * from "./NewsListSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports